// extracted by mini-css-extract-plugin
module.exports = {"PersonCardSliderSection":"PersonCardSliderSection_PersonCardSliderSection__UZO_C"};